import { ApplicationErrorType } from "./application-error.types";
import { ApplicationError } from "./application-error";

/**
 * Extension of the ApplicationError class for Http errors
 */
export class DeeplinkApplicationError extends ApplicationError
{
    //#region Constructor

    /**
     * Class constructor
     * @param message 
     * @param errorType 
     */
    constructor
        (
            device: string,
            applicationVersion: string,
            softwareVersion: string,
            userAgent: string,
            route: string
        )
    {
        super(`Failed to match deeplink: ${route}`, ApplicationErrorType.ERROR_DEEPLINK, device, applicationVersion, softwareVersion, userAgent);
    }

    //#endregion
}